<template>
    <v-menu offset-y :close-on-content-click="false">
        <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" small class="mr-n2">
                <v-icon left>mdi-tune-variant</v-icon>
                <span>Filters</span>
            </v-btn>
        </template>
        <v-list nav dense>
            <div v-for="spaceTypeKey in spaceTypeOrder" :key="`space-type-filter-${spaceTypeKey}`">
                <v-sheet rounded class="py-2 px-4 my-1">
                    <v-switch
                        inset
                        dense
                        hide-details
                        class="pa-0 ma-0"
                        :input-value="isSelected(spaceTypeKey)"
                        @change="setSpaceTypeSelection(spaceTypeKey, $event)">
                        <template v-slot:label>
                            <div class="d-flex align-center">
                                <v-icon left small :class="spaceTypeMetaByKey(spaceTypeKey).iconColorClass">
                                    {{ spaceTypeMetaByKey(spaceTypeKey).icon }}
                                </v-icon>
                                <span :class="`text-capitalize ${spaceTypeMetaByKey(spaceTypeKey).iconColorClass}`">
                                    {{ spaceTypeMetaByKey(spaceTypeKey).pluralLabel }}
                                </span>
                            </div>
                        </template>
                    </v-switch>
                </v-sheet>
            </div>
            <template v-if="showInactive !== undefined">
                <v-divider class="my-1"></v-divider>
                <v-sheet rounded class="py-2 px-4 my-1">
                    <v-switch :input-value="showInactive" inset dense hide-details class="pa-0 ma-0" @change="$emit('update:showInactive', $event)">
                        <template v-slot:label>
                            <div class="d-flex align-center">
                                <v-icon left small color="secondary">mdi-sleep</v-icon>
                                <span>Inactive</span>
                            </div>
                        </template>
                    </v-switch>
                </v-sheet>
            </template>
        </v-list>
    </v-menu>
</template>

<script>
import { SPACE_TYPE_ORDER } from '@/utils/spaceTypeMeta'
import spaceTypeUi from '@/mixins/spaceTypeUi'

export default {
    name: 'SpaceTypeFilterMenu',
    mixins: [spaceTypeUi],
    props: {
        value: {
            type: Array,
            default: null
        },
        showInactive: {
            type: Boolean,
            default: undefined
        }
    },
    computed: {
        spaceTypeOrder() {
            return SPACE_TYPE_ORDER
        },
        selectedSpaceTypes() {
            if (!Array.isArray(this.value)) {
                return this.spaceTypeOrder.slice()
            }

            const validSpaceTypes = this.value.filter(type => this.spaceTypeOrder.includes(type))
            return Array.from(new Set(validSpaceTypes))
        }
    },
    methods: {
        isSelected(spaceTypeKey) {
            return this.selectedSpaceTypes.includes(spaceTypeKey)
        },
        setSpaceTypeSelection(spaceTypeKey, selected) {
            const nextSelectedSpaceTypes = [...this.selectedSpaceTypes]

            if (selected) {
                if (!nextSelectedSpaceTypes.includes(spaceTypeKey)) {
                    nextSelectedSpaceTypes.push(spaceTypeKey)
                }
            } else {
                const typeIndex = nextSelectedSpaceTypes.indexOf(spaceTypeKey)
                if (typeIndex !== -1) {
                    nextSelectedSpaceTypes.splice(typeIndex, 1)
                }
            }

            this.$emit('input', nextSelectedSpaceTypes)
        }
    }
}
</script>
